import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { getUserId } from "services/storage/general";
import helpers from "./helpers";

export async function requestGetUniversitySpaces({
	campusId, spaceTypeId,
	activityId, studentId,
	date, page
}) {
	const [result, err] = await doRequest(
		"/EspacioUniversitario/ObtenerListaEspacios", "POST",
		{
			idCampus: campusId,
			idTipoEspacio: spaceTypeId,
			idActividad: activityId,
			codigoEstudiante: studentId,
			fecha: date,
			pagina: page,
			codigoUsuario: getUserId()
		}, getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data.data?.mensaje) {
		return {
			error: data.data.mensaje,
		};
	}
	const { espacios, total } = data.data;
	return {
		resources: espacios?.map(helpers.parseToUniversitySpace),
		total: total,
		error: null,
	};
}

export async function requestSaveReservationState({
	reservationId,
	finalized,
	reservationType
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/GuardarEstado",
		"POST",
		{
			idReserva: reservationId,
			finalizado: finalized,
			tipoReserva: reservationType,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			newTimeEnd: null
		};
	const { data } = result.data;
	return {
		success: data.exito,
		newTimeEnd: data?.nuevaHoraFin || null
	};
}

export async function requestCancelReservation({
	reservationId,
	reservationType,
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/CancelarReserva",
		"POST",
		{
			idReserva: reservationId,
			tipoReserva: reservationType,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data?.exito;
}

export async function requestAddStudentsToSpaceReservation({
	students, reservationId
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/AgregarAlumno",
		"POST",
		{
			idReserva: reservationId,
			estudiantes: students.map(({ id, name }) => ({
				codAlumno: id,
				nombreAlumno: name,
			})),
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null,
			studentsWithErrors: []
		};
	const { data } = result;
	if (![1, 0].includes(data?.state))
		return {
			success: true,
			message: null,
			studentsWithErrors: []
		};
	const { exito, mensaje, alumnos } = data.data;
	return {
		success: exito,
		message: mensaje || null,
		studentsWithErrors: alumnos ? alumnos.map(({
			codAlumno, nombreAlumno
		}) => ({
			id: codAlumno,
			name: nombreAlumno
		})) : []
	};
}

export async function requestValidateDeletionStudentInSpaceReservation({
	reservationDetailIds
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/ValidarEliminacion",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.exito;
}

export async function requestDeleteStudentsFromSpaceReservation({
	reservationDetailIds
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/EliminarAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null
		};
	const { data } = result;
	if (![1, 0].includes(data?.state))
		return {
			success: true,
			message: null
		};
	const { exito, mensaje } = data.data;
	return {
		success: exito,
		message: mensaje || null,
	};
}

export async function requestTakeStudentAttendanceInSpaceReservation({
	reservationDetailIds
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/AsistenciaAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.exito;
}

export async function requestValidatePenalize({
	reservationDetailIds,
	spaceTypeId
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/ValidarCrearSancion",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			idTipoEspacio: spaceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.alumnosConSancion.map(({ idAlumno, nombres }) => ({
		id: idAlumno,
		name: nombres,
	}));
}

export async function requestValidateUpdatePenalty({
	studentPenalizedIds,
	spaceTypeId,
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/ValidarEditarSancion",
		"POST",
		{
			idsAlumnosSancionados: studentPenalizedIds,
			idTipoEspacio: spaceTypeId,
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	// "SANCIONES_DIFERENTES"
	return data.data.mensaje;
}

export async function requestPenalizeStudent({
	reservationDetailIds,
	reasonForPenalizeId,
	penalizeDays,
	details, spaceTypeId
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/SancionarAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			idMotivo: reasonForPenalizeId,
			dias: parseInt(penalizeDays),
			detalles: details || null,
			idTipoEspacio: spaceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
}

export async function requestUpdatePenaltyStudent({
	studentPenalizedIds, penalizeDays,
	details, spaceTypeId
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/EditarSancionAlumno",
		"POST",
		{
			idsAlumnosSancionados: studentPenalizedIds,
			dias: parseInt(penalizeDays),
			detalles: details || null,
			idTipoEspacio: spaceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
}

export async function requestRegisterSpaceAdminReservation({
	spaceId, name, details,
	date, timeStart, timeEnd
}) {
	const [result, err] = await doRequest(
		"/ReservaEspacioUniversitario/ReservaManual",
		"POST",
		{
			idEspacioUniversitario: spaceId,
			nombre: name,
			detalles: details,
			fecha: date,
			horaInicio: timeStart,
			horaFin: timeEnd,
			codigoUsuario: getUserId()
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
}
